/**
 * WorksheetBatchIntakePage — page10 Slice 3 (Q-T040) route-wrapper a csoportos beadáshoz.
 *
 * A placement-agnoszt `WorksheetBatchIntakeForm`-ot (#471) mountolja a `/worksheet/batch`
 * route-on (a `/worksheet/new` egy-munkalap-create mintájára). A `onSuccess` zárja a loopot:
 * az első létrehozott munkalap detail-oldalára navigál, ahol a #439 `WorksheetBatchPanel`
 * natívan megjeleníti a teljes beadás-csoportot (közös `intakeBatchId`, al-számokkal).
 */
import type { WorksheetBatchResponse } from '@/api/worksheets';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { WorksheetBatchIntakeForm } from './components/WorksheetBatchIntakeForm';

export function WorksheetBatchIntakePage() {
  const navigate = useNavigate();

  const handleSuccess = useCallback(
    (result: WorksheetBatchResponse['data']) => {
      // Loop-closure: az első munkalap detail-oldala — ott a WorksheetBatchPanel (#439)
      // listázza a teljes beadást. Defenzív fallback a listára, ha üres lenne a válasz.
      const first = result.worksheets[0];
      navigate(first ? `/worksheet/${first.id}` : '/worksheet');
    },
    [navigate]
  );

  const handleCancel = useCallback(() => navigate('/worksheet'), [navigate]);

  return (
    <div
      className="container mx-auto max-w-4xl p-4 md:p-6"
      data-testid="worksheet-batch-intake-page"
    >
      <WorksheetBatchIntakeForm onSuccess={handleSuccess} onCancel={handleCancel} />
    </div>
  );
}
